import * as Modals from "components/Modals";

document.addEventListener("DOMContentLoaded", function () {
  Modals.init();
});
